
// Values passed in via the `DefinePlugin` (see webpack config)
declare const DEFINE_PUBLIC_PATH: string | null;
declare const DEFINE_SETTINGS_PATH: string | null;
declare const DEFINE_BUILD_DATE: string | null;
declare const DEFINE_COMMIT_SHA: string | null;
declare const DEFINE_POSTHOG_ENABLED: boolean;

export const DEFINES = {
  publicPath: DEFINE_PUBLIC_PATH ?? "/",
  settingsPath: DEFINE_SETTINGS_PATH,
  buildDate: DEFINE_BUILD_DATE,
  commitSha: DEFINE_COMMIT_SHA,
  posthogEnabled: DEFINE_POSTHOG_ENABLED,
};
